var exports = {
  "wrap": "x234b8571--370f9b--wrap",
  "tabs": "x234b8571--370f9b--tabs",
  "wrap-left-blur": "x234b8571--370f9b--wrap-left-blur",
  "wrap-right-blur": "x234b8571--370f9b--wrap-right-blur",
};

module.exports = exports;
